import React from 'react';

import Hero5day from '@/assets/roadtrip-guides/5day_hero.jpg';

import css from './DirectoryHero.module.css';

interface IProps {
  title: string;
  subTitle: string;
}

const DirectoryHero: React.FC<IProps> = ({ title, subTitle }) => {
  return (
    <div
      className={`flex flex-col items-center relative text-center justify-center w-full text-white p-4 ${css.heroBanner}`}>
      <div className="absolute z-0 w-full h-full">
        <div
          className="h-full bg-center bg-cover"
          style={{ backgroundImage: `url('${Hero5day.src}')` }}
        />
      </div>
      <div className="z-20 flex flex-col items-center max-w-lg">
        <h1 className="text-3xl font-medium leading-tight text-center md:text-4xl">{title}</h1>
        <h2 className="text-2xl font-medium leading-tight text-center md:text-2xl">{subTitle}</h2>
      </div>
    </div>
  );
};

export default DirectoryHero;
